













































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import Footers from '@/components/Footers.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {GetAdminsTempServiceRequest, PutAdminsTempServiceRequest, GetAdminsTempServiceExistsRequest} from 'supporter';
import Logo from '@/components/common/Logo.vue';

@Component({
  components: { Logo, Footers, CompSelectBox},
  directives: {ClickOutside}
})
export default class RegisterForm extends Vue {
  private adminName: string = '';
  private tempCode = this.$route.query.tempCode;
  private ifCheck: boolean = false;

  private adminIdGuide: boolean = false;
  private adminIdShort: boolean = false;
  private adminIdResultPass: boolean = false;
  private adminIdResultFail: boolean = false;

  private adminPasswordDescription: boolean = false;
  private adminPasswordFailShort: boolean = false;
  private adminPasswordComplexityAtLeast2: boolean = false;
  private adminPasswordComplexityAtLeast3: boolean = false;
  private adminPasswordNotAllowSpecial: boolean = false;

  private passwordPassGuide: boolean = false;
  private passwordFailGuide: boolean = false;
  private isPasswordConfirmed: boolean = false;

  private isPasswordValid: boolean = false;

  private countryCode: string = 'KR';
  private errorPhoneNo: boolean = false;
  private errorMobileNo: boolean = false;

  private ad: string = '';
  private pass: string = '';
  private passConfirm: string = '';
  private status: boolean = false;

  private MOBILE_NO_ONLY_NUM = /^01\d{8,9}$/;
  private MOBILE_NO = /^01\d-\d{3,4}-\d{4}$/;

  private serviceName: string = '';
  // SMS Auth
  private isFormGuideFail: boolean = false;
  private smsAuthKeyInputRow: boolean = false;
  private smsAuthSendGuide: boolean = false;
  private rowSpan: string = '1';
  private smsAuthKey: string = '';
  private smsCertSuccess: boolean = false;
  private smsCertFail: boolean = false;

  private serviceNo: number = 0;

  private theForm: PutAdminsTempServiceRequest = {
    data: {
      password: '',
      passwordConfirm: '',
      adminId: '',
      departmentNo: null,
      smsAuthKey: '',
      tempCode: this.tempCode as string,
      mobileNo: '',
      jobPositionName: '',
      phoneNo: '',
      externalAccessEnabled: false,
      jobDutyNo: null
    }
  };
  private departmentNoData = [
    {
      value: null,
      name: 'ADMIN_SERVICE_SELECT_DEPARTMENT'
    }
  ];
  private jobDutyNoData = [
    {
      value: null,
      name: 'ADMIN_SERVICE_SELECT_JOBDUTY'
    }
  ];
  private async mounted() {
    await this.checkStatus();
  }
  private destroyed() {
    $('#container').removeClass('layout_error');
    $('body').removeClass('error_page');
  }
  @Watch('pass')
  watchPass() {
    if (this.pass || this.pass === '') {
      $('input[name=adminPassword]').attr('type', 'password');
    } else {
      $('input[name=adminPassword]').attr('type', 'text');
    }
  }
  @Watch('passConfirm')
  watchPassConfirm() {
    if (this.passConfirm || this.passConfirm === '') {
      $('input[name=adminPasswordConfirm]').attr('type', 'password');
    } else {
      $('input[name=adminPasswordConfirm]').attr('type', 'text');
    }
  }

  private checkStatus() {
    const request = {
      params: {
        tempCode: this.tempCode as string
      }
    };
    this.$api
      .getAdminsTempService(request as GetAdminsTempServiceRequest)
      .then((ret) => {
        const status = ret.data.adminStatus;
        if (status === 'ACTIVE') {
          document.close();
          alert(window.$t('ADMIN_SERVICE_REGISTER_OVER'));
          location.href = '/login';
        }
        if (status === 'DELETE') {
          document.close();
          alert(window.$t('ADMIN_SERVICE_ALREADY_DELETE'));
          location.href = '/login';
        }
        this.adminName = ret.data.adminName;
        this.theForm.data.externalAccessEnabled = ret.data.externalAccessEnabled;
        this.serviceNo = ret.data.serviceNo;
        this.serviceName = ret.data.serviceName;
        ret.data.departments.forEach((e) => {
          this.departmentNoData.push({
            value: e.departmentNo,
            name: e.departmentName
          });
        });
        ret.data.jobDuties.forEach((e) => {
          this.jobDutyNoData.push({
            value: e.jobDutyNo,
            name: e.jobDutyName
          });
        });
      })
      .catch(() => {
        $('#container').removeClass('layout_agreeTerms');
        $('#container').addClass('layout_error');
        $('body').addClass('error_page');
        this.status = true;
      });
  }
  private onClickSmsCertBtn() {
    const mobileNo = this.theForm.data.mobileNo;
    if (!this.MOBILE_NO.test(mobileNo) && !this.MOBILE_NO_ONLY_NUM.test(mobileNo)) {
      this.isFormGuideFail = true;
      return;
    }
    this.isFormGuideFail = false;

    const serviceNo = this.serviceNo;

    this.rowSpan = '2';
    this.smsAuthKeyInputRow = true;

    this.$api
      .postAuthSms({data: {mobileNo: mobileNo}})
      .then(() => {
        this.smsAuthSendGuide = true;
      })
      .catch(() => {
        alert(window.$t('ADMIN_SERVICE_SERVER_ERROR'));
      });
  }
  private removeSmsCertRows() {
    this.rowSpan = '1';
    this.smsAuthKeyInputRow = false;
    this.smsAuthSendGuide = false;
    this.smsCertSuccess = false;
    this.smsCertFail = false;
    this.smsAuthKey = '';
  }
  private onClickSmsCheckBtn() {
    const mobileNo = this.theForm.data.mobileNo;
    const key = this.smsAuthKey;

    this.$api
      .getAuthSms({params: {mobileNo: mobileNo, key: key}})
      .then(() => {
        this.smsCertSuccess = true;
      })
      .catch(() => {
        this.smsCertSuccess = false;
        this.smsCertFail = true;
      });
  }
  private removeSmsCheckGuide() {
    this.smsCertSuccess = false;
    this.smsCertFail = false;
  }
  private showAdminIdShort() {
    this.adminIdGuide = false;
    this.adminIdShort = true;
    this.adminIdResultPass = false;
    this.adminIdResultFail = false;
  }
  private showAdminIdDuplicationFailGuide() {
    this.adminIdResultPass = false;
    this.adminIdResultFail = true;
    this.adminIdGuide = false;
    this.adminIdShort = false;
  }
  private showAdminIdDuplicationPassGuide() {
    this.adminIdResultPass = true;
    this.adminIdResultFail = false;
    this.adminIdGuide = false;
    this.adminIdShort = false;
    this.ifCheck = true;
  }
  private removePasswordConfirmGuides() {
    this.passwordPassGuide = false;
    this.passwordFailGuide = false;
    this.adminPasswordDescription = false;
    this.isPasswordConfirmed = false;
  }
  private removeAdminIdDuplicationGuides() {
    this.adminIdGuide = true;
    this.adminIdShort = false;
    this.adminIdResultPass = false;
    this.adminIdResultFail = false;

    this.ifCheck = false;
  }
  private removePasswordValidationGuides() {
    this.removePasswordFailGuides();
    this.adminPasswordDescription = true;
    this.isPasswordValid = false;
  }
  private removePasswordFailGuides() {
    this.adminPasswordFailShort = false;
    this.adminPasswordComplexityAtLeast2 = false;
    this.adminPasswordComplexityAtLeast3 = false;
    this.adminPasswordNotAllowSpecial = false;
  }
  private hidePasswordGuides() {
    this.removePasswordFailGuides();
    this.adminPasswordDescription = false;
  }
  private showPasswordNotAllow(result: any) {
    this.hidePasswordGuides();
    switch (result) {
      case this.resultNcpPolicyPasswordEnum.AT_LEAST2:
        this.adminPasswordComplexityAtLeast2 = true;
        break;
      case this.resultNcpPolicyPasswordEnum.AT_LEAST3:
        this.adminPasswordComplexityAtLeast3 = true;
        break;
      case this.resultNcpPolicyPasswordEnum.NOT_ALLOW_SPECAIL:
        this.adminPasswordNotAllowSpecial = true;
        break;
      default:
        throw new Error(window.$t('ADMIN_SERVICE_ERROR_HAPPEN'));
    }
  }
  private keyupCheckTel(e) {
    const value = e.target.value;
    const validate = /[^0-9\-]/g.test(value);
    if(validate){
      this.errorPhoneNo = true;
    }else{
      this.errorPhoneNo = false;
    }
    if (!value) {
      this.errorPhoneNo = false;
    }
    e.target.value = value.replace(/[^0-9\-]/g, '');
    this.theForm.data.phoneNo = e.target.value;
  }
 
  private blurPhone () {
    this.errorPhoneNo = false;
  }
  private keyupCheckMobile(e) {
    const value = e.target.value;
    const validate = /[^\d\-]/g.test(value);
 
    if (validate) {
      this.errorMobileNo = true;
    } else {
      this.errorMobileNo = false;
    }
    if (!value) {
      this.errorMobileNo = false;
    }
    e.target.value = value.replace(/[^\d\-]/g, '');
    this.theForm.data.mobileNo = e.target.value;
  }

  private blurMobile() {
    this.errorMobileNo = false;
  }

  private keyupAdminId(e) {
    let newValue = e.target.value.replace(/[^0-9a-z]/g, '');
    const splitNewValue = newValue.split(/[a-z]/);
    if (/[0-9]/g.test(splitNewValue[0])) {
      newValue = newValue.slice(splitNewValue[0].length, newValue.length);
    }
    e.target.value = newValue;
    this.ad = e.target.value;
  }

  private validateNcpPolicyPassword(password: any) {
    const patternNumber = /[0-9]/g;
    const patternEnglish = /[a-zA-Z]/gi;
    const patternSpecial = /[!@#$%^&+=\-_.()]/g;

    const checkNumber = patternNumber.test(password) ? 1 : 0;
    const checkEnglish = patternEnglish.test(password) ? 1 : 0;
    const checkSpecial = patternSpecial.test(password) ? 1 : 0;
    const checkSum = checkNumber + checkEnglish + checkSpecial;

    const filteringPassword = password.replace(patternNumber, '').replace(patternEnglish, '').replace(patternSpecial, '');

    let result = this.resultNcpPolicyPasswordEnum.SUCCESS;
    if (filteringPassword.length > 0) {
      result = this.resultNcpPolicyPasswordEnum.NOT_ALLOW_SPECAIL;
    } else {
      if (password.length < 10) {
        if (checkSum < 3) {
          result = this.resultNcpPolicyPasswordEnum.AT_LEAST3;
        }
      } else if (checkSum < 2) {
        result = this.resultNcpPolicyPasswordEnum.AT_LEAST2;
      }
    }
    return result;
  }
  private resultNcpPolicyPasswordEnum = {
    SUCCESS: 0,
    NOT_ALLOW_SPECAIL: 1,
    AT_LEAST2: 2,
    AT_LEAST3: 3
  };
  private validateAdminPassword() {
    const password = this.pass;
    const minLength = 8;
    const maxLength = 20;
    if (password.length < minLength) {
      this.hidePasswordGuides();
      this.adminPasswordFailShort = true;
      this.isPasswordValid = false;
    } else if (password.length > maxLength) {
      this.hidePasswordGuides();
      this.adminPasswordDescription = true;
      this.isPasswordValid = false;
    } else {
      const result = this.validateNcpPolicyPassword(password);
      if (result == this.resultNcpPolicyPasswordEnum.SUCCESS) {
        this.hidePasswordGuides();
        this.isPasswordValid = true;
      } else {
        this.showPasswordNotAllow(result);
      }
    }

    const confirmPassword = this.passConfirm;
    if (confirmPassword) {
      this.confirmAdminPassword();
    }
  }
  private back2Main() {
    this.$router.replace('/')
  }
  private confirmAdminPassword() {
    const password = this.pass;
    const confirmPassword = this.passConfirm;

    if (password === confirmPassword && this.isPasswordValid) {
      this.passwordPassGuide = true;
      this.passwordFailGuide = false;
      this.isPasswordConfirmed = true;
    } else {
      this.passwordPassGuide = false;
      this.passwordFailGuide = true;
      this.isPasswordConfirmed = false;
    }
  }
  private keyupSmsAuthKey(e) {
    const newValue = e.target.value.replace(/[^0-9]/g, '');
    e.target.value = newValue;
    this.smsAuthKey = e.target.value;
  }

  private onClickCheckDuplicatedAdminIdButton() {
    if (this.ad.length < 5) {
      this.showAdminIdShort();
      return;
    }
    if (this.ad.length > 0) {
      const request = {
        params: {
          adminId: this.ad as string
        }
      };
      this.$api.getAdminsTempServiceExists(request as GetAdminsTempServiceExistsRequest).then((ret) => {
        if (ret.data.exists === true) {
          // fail
          this.showAdminIdDuplicationFailGuide();
          this.ifCheck = false;
        } else {
          // pass
          this.showAdminIdDuplicationPassGuide();
        }
      });
    } else {
      alert(window.$t('ADMIN_SERVICE_NEED_ID'));
    }
  }

  private isFormPassed() {
    if (!this.ifCheck) {
      alert(window.$t('ADMIN_SERVICE_CHECK_ID_DUO'));

      return false;
    }

    if (!this.isPasswordConfirmed) {
      alert(window.$t('ADMIN_SERVICE_CHECK_PASS'));

      return false;
    }

    // if (this.theForm.data.jobPositionName.trim().length === 0) {
    //   alert(window.$t('ADMIN_SERVICE_NEED_JOB_POSITION'));

    //   return false;
    // }
    if (!this.theForm.data.phoneNo.trim()) {
      alert(window.$t('ADMIN_SERVICE_NEED_PHONE'));

      return false;
    }

    if (this.countryCode === 'KR') {
      if (!this.theForm.data.mobileNo.trim()) {
        alert(window.$t('ADMIN_SERVICE_NEED_MOBILE'));

        return false;
      } else if (!this.MOBILE_NO.test(this.theForm.data.mobileNo) && !this.MOBILE_NO_ONLY_NUM.test(this.theForm.data.mobileNo)) {
        alert(window.$t('ADMIN_SERVICE_MOBILE_TYPE_CHECK'));
        return false;
      }

      if (this.smsCertSuccess === false) {
        alert(window.$t('ADMIN_SERVICE_SMS_CERTIFICATE_CHECK'));

        return false;
      }
    }

    const result = this.validateNcpPolicyPassword(this.pass);
    if (result != this.resultNcpPolicyPasswordEnum.SUCCESS) {
      if (result == this.resultNcpPolicyPasswordEnum.AT_LEAST2) {
        alert($.trim(window.$t('ADMIN_SERVICE_AT_LEAST_2')));
      } else if (result == this.resultNcpPolicyPasswordEnum.AT_LEAST3) {
        alert($.trim(window.$t('ADMIN_SERVICE_AT_LEAST_3')));
      } else if (result == this.resultNcpPolicyPasswordEnum.NOT_ALLOW_SPECAIL) {
        alert($.trim(window.$t('ADMIN_SERVICE_NOT_SPECIAL')));
      }
      return false;
    }

    if (confirm(window.$t('ADMIN_SERVICE_CONFIRM_SEND'))) {
      return true;
    }

    return false;
  }
  private onClickNextButton() {
    // 다음페이지로 이동
    if (this.isFormPassed()) {
      this.theForm.data.adminId = this.ad;
      this.theForm.data.password = this.pass;
      this.theForm.data.passwordConfirm = this.passConfirm;
      this.theForm.data.smsAuthKey = this.smsAuthKey;
      this.$api.putAdminsTempService(this.theForm as PutAdminsTempServiceRequest).then(() => {
        location.href = `/admin/service/registerCompletePage?tempCode=${this.tempCode}`;
      })
    }
  }
}
